import React from 'react';
import {Chip} from "@mui/material";
import {alpha, darken, useTheme} from "@mui/material/styles";
import {useTranslation} from "react-i18next";
import {SectionStatus} from "../../utils/contaminationDeclaration/gating";
import {sectionStatusColor} from "./statusColors";

interface Props {
    status: SectionStatus;
    /** Open question count, shown as "N open" while answers are missing. */
    openCount?: number;
}

/**
 * Section status tag. Same base color as the progress panel's dot for that
 * status (tinted background, darkened text for legibility), no icon.
 */
const SectionStatusChip = ({status, openCount}: Props) => {
    const {t} = useTranslation();
    const theme = useTheme();

    const label = status === 'complete'
        ? t('Complete')
        : status === 'missing'
            ? (openCount && openCount > 0 ? t('{{count}} open', {count: openCount}) : t('Answers missing'))
            : status === 'inactive'
                ? t('Not applicable')
                : null;
    if (!label) return null;

    const color = sectionStatusColor(theme, status);
    return (
        <Chip
            size="small"
            label={label}
            data-testid="doc-section-status"
            sx={{
                height: 22, fontWeight: 500,
                backgroundColor: alpha(color, 0.18),
                color: darken(color, 0.45),
            }}
        />
    );
};

export default SectionStatusChip;
